import { ConversationPhase } from "shared/types";
import { getText, interpolate } from "shared/lib";

import { useCouncilLocalisation } from "shared/hooks";
import { useAccount } from "@/hooks";

export function HelpMessage() {
  const { conversation } = useAccount();
  const { getLocalisationEntry } = useCouncilLocalisation(conversation);

  const isReportComplete =
    conversation?.phase === ConversationPhase.sent_to_council;

  return (
    <div className="text-bodylg text-textPrimary flex flex-col gap-4">
      <div>
        <p>
          {interpolate(
            "If you want to discuss your proposal with a planner, {{link}}.",
            {
              link: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href={getLocalisationEntry("councilContactLink")}
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("contact Council")}
                </a>
              ),
            },
          )}
        </p>

        {isReportComplete ? (
          <div className="flex flex-col gap-2">
            <p>When you contact Council, quote your session ID:</p>
            <span className="border-interactiveBorder bg-interfaceWhite w-min whitespace-nowrap rounded border px-2 py-1.5">
              {conversation?.identifier?.toUpperCase() || ""}
            </span>
          </div>
        ) : null}
      </div>

      <p>
        {interpolate(
          "You may also find an answer to your question in the {{link}} of the council's website.",
          {
            link: (
              <a
                className="text-textLink hover:text-textLinkHover underline"
                href={getLocalisationEntry("councilPlanningWebsite")}
                rel="noreferrer"
                tabIndex={0}
                target="_blank"
              >
                {getText("planning section")}
              </a>
            ),
          },
        )}
      </p>
    </div>
  );
}
